import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const MenuOutlinedIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2L2 2L2 5H5V2ZM14 2L11 2V5H14V2ZM5 11H2L2 14H5V11ZM14 11H11V14H14V11ZM2 0C0.895431 0 0 0.89543 0 2V5C0 6.10457 0.89543 7 2 7H5C6.10457 7 7 6.10457 7 5V2C7 0.895431 6.10457 0 5 0H2ZM11 0C9.89543 0 9 0.89543 9 2V5C9 6.10457 9.89543 7 11 7H14C15.1046 7 16 6.10457 16 5V2C16 0.895431 15.1046 0 14 0H11ZM0 11C0 9.89543 0.895431 9 2 9H5C6.10457 9 7 9.89543 7 11V14C7 15.1046 6.10457 16 5 16H2C0.89543 16 0 15.1046 0 14V11ZM11 9C9.89543 9 9 9.89543 9 11V14C9 15.1046 9.89543 16 11 16H14C15.1046 16 16 15.1046 16 14V11C16 9.89543 15.1046 9 14 9H11Z"
        fill={props.color}
      />
    </IconWrapper>
  );
};

export default MenuOutlinedIcon;
